import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import SettingsSideBar from "../components/SettingsSideBar";
import MyProfileSettings from "./MyProfileSettings";
import NotificationSettings from "./NotificationSettings";
import SettingsPrivacy from "./SettingsPrivacy";

function Settings() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("menu");
  const [searchParams, setSearchParams] = useSearchParams();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const handleChangeSection = (section) => {
    setActiveSection(section);
    setSearchParams({ section });
    localStorage.setItem("activeSettingsSection", section);
  };

  const handleBack = () => {
    setActiveSection("menu");
    setSearchParams({});
    localStorage.setItem("activeSettingsSection", "menu");
  };

  useEffect(() => {
  
    const sectionFromURL = searchParams.get("section");
    const savedSection = localStorage.getItem("activeSettingsSection");

    if (sectionFromURL) {
      setActiveSection(sectionFromURL);
      localStorage.setItem("activeSettingsSection", sectionFromURL);
    } else if (savedSection) {
      setActiveSection(savedSection);
    } else {
      const defaultSection = window.innerWidth > 768 ? "profile" : "menu";
      setActiveSection(defaultSection);
      localStorage.setItem("activeSettingsSection", defaultSection);
    }
  }, [searchParams]);

    return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="bottom-content">
          <h5 className="accounttexthide">Account Settings</h5>
          <div className="settings-wrap row">
            <div
              className={`col-md-3 settings-sidebar-wrap ${
                activeSection !== "menu" ? "mobile-hidden" : ""
              }`}
            >
              <SettingsSideBar
                active={activeSection}
                onChange={handleChangeSection}
              />
            </div>

            <div
              className={`col-md-9 settings-content ${
                activeSection === "menu" ? "mobile-hidden" : ""
              }`}
            >
              <button className="settings-back-btn" onClick={handleBack}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="15"
                  viewBox="0 0 7 12"
                  fill="none"
                >
                  <path
                    d="M5.99723 10.7999C5.99723 10.7999 1.19728 7.26478 1.19727 5.99989C1.19725 4.735 5.99727 1.19993 5.99727 1.19993"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {activeSection === "profile" && <MyProfileSettings />}
              {activeSection === "notifications" && <NotificationSettings />}
              {activeSection === "privacy" && <SettingsPrivacy />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Settings;
